export function ButtonRound({ text }) {
  return /* html */ `
  <span class="hidden">{{ text }}</span>
  <div class="c-button-icon">
    <span class="c-button-icon-static">
      <svg class="c-icon-arrow-top" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.85742 6.47376L7.58128 2.7499C8.10198 2.2292 8.9462 2.2292 9.4669 2.7499L13.1908 6.47376M8.52409 2.63737L8.52409 13.6404"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </span>
    <span class="c-button-icon-hover">
      <svg class="c-icon-arrow-top" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.85742 6.47376L7.58128 2.7499C8.10198 2.2292 8.9462 2.2292 9.4669 2.7499L13.1908 6.47376M8.52409 2.63737L8.52409 13.6404"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </span>
  </div>`
}

